export enum CheckInForm {
  CheckIn = 'CheckIn',
  SendCode = 'SendCode',
}
